(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["event-cards-showcase"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.eventCardsShowcaseInitialized) return;
    window.eventCardsShowcaseInitialized = true;

    const mobileQuery = window.matchMedia('(max-width: 768px)');
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplayDelay = 5000;

    const getState = (root) => {
      root.eventCardsShowcaseState = root.eventCardsShowcaseState || { index: 0, timer: null, paused: false };
      return root.eventCardsShowcaseState;
    };

    const getSlides = (root) => Array.from(root.querySelectorAll('[data-event-cards-slide]'));

    const stopAutoplay = (root) => {
      const state = getState(root);
      if (state.timer) {
        window.clearInterval(state.timer);
        state.timer = null;
      }
    };

    const canAutoplay = (root) => getSlides(root).length > 1 && mobileQuery.matches && !reduceMotionQuery.matches;

    const setActive = (root, nextIndex) => {
      const state = getState(root);
      const slides = getSlides(root);
      const track = root.querySelector('[data-event-cards-track]');
      if (!track || slides.length === 0) return;

      const normalizedIndex = (nextIndex + slides.length) % slides.length;
      state.index = normalizedIndex;
      track.style.transform = mobileQuery.matches ? `translateX(-${normalizedIndex * 100}%)` : 'none';

      root.querySelectorAll('[data-event-cards-dot]').forEach((dot) => {
        const isActive = Number(dot.dataset.eventCardsDot) === normalizedIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    };

    const startAutoplay = (root) => {
      const state = getState(root);
      stopAutoplay(root);
      if (!canAutoplay(root) || state.paused) return;

      state.timer = window.setInterval(() => {
        setActive(root, state.index + 1);
      }, autoplayDelay);
    };

    const initializeRoot = (root) => {
      if (root.dataset.eventCardsInitialized === 'true') return;
      root.dataset.eventCardsInitialized = 'true';

      setActive(root, getState(root).index);
      startAutoplay(root);

      root.addEventListener('mouseenter', () => {
        getState(root).paused = true;
        stopAutoplay(root);
      });

      root.addEventListener('mouseleave', () => {
        getState(root).paused = false;
        startAutoplay(root);
      });

      root.addEventListener('focusin', () => {
        getState(root).paused = true;
        stopAutoplay(root);
      });

      root.addEventListener('focusout', () => {
        getState(root).paused = false;
        startAutoplay(root);
      });
    };

    document.addEventListener('click', (event) => {
      const previousButton = event.target.closest('[data-event-cards-prev]');
      const nextButton = event.target.closest('[data-event-cards-next]');
      const dotButton = event.target.closest('[data-event-cards-dot]');
      const control = previousButton || nextButton || dotButton;
      if (!control) return;

      const root = control.closest('[data-event-cards-root]');
      if (!root) return;

      const state = getState(root);
      if (previousButton) setActive(root, state.index - 1);
      if (nextButton) setActive(root, state.index + 1);
      if (dotButton) setActive(root, Number(dotButton.dataset.eventCardsDot));
      startAutoplay(root);
    });

    const refreshRoots = () => {
      document.querySelectorAll('[data-event-cards-root]').forEach((root) => {
        initializeRoot(root);
        setActive(root, getState(root).index);
        startAutoplay(root);
      });
    };

    refreshRoots();
    window.addEventListener('resize', refreshRoots);
    document.addEventListener('shopify:section:load', refreshRoots);
    if (typeof mobileQuery.addEventListener === 'function') mobileQuery.addEventListener('change', refreshRoots);
    if (typeof reduceMotionQuery.addEventListener === 'function') reduceMotionQuery.addEventListener('change', refreshRoots);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["testimonial-wall-showcase"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.testimonialWallDialogsInitialized) return;
    window.testimonialWallDialogsInitialized = true;

    const closeDialog = (dialog) => {
      if (!dialog) return;

      if (typeof dialog.close === 'function') {
        dialog.close();
        return;
      }

      dialog.removeAttribute('open');
    };

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-testimonial-wall-open]');
      if (openButton) {
        const dialogId = openButton.getAttribute('data-testimonial-wall-open');
        const sectionRoot = openButton.closest('[data-testimonial-wall-root]');
        const dialog = sectionRoot?.querySelector(`[data-testimonial-wall-dialog="${dialogId}"]`);

        if (!dialog) return;

        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        return;
      }

      const closeButton = event.target.closest('[data-testimonial-wall-close]');
      if (closeButton) {
        closeDialog(closeButton.closest('dialog'));
        return;
      }

      if (event.target.matches('[data-testimonial-wall-dialog]')) {
        closeDialog(event.target);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
